import { apiClient } from '~/api/client';

export type ToggleSyncedParams = {
  list_id: string;
  synced: boolean;
};

export const toggleSynced = async ({ list_id, synced }: ToggleSyncedParams) =>
  apiClient.put(`/lists/${list_id}/toggle_synced`, { synced });
